import React from 'react';
import { Frown } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
const pains = [{
  title: '"Mi hijo habla menos que el hijo de mi amiga y no sé si está bien."',
  desc: 'Ves que otros chicos de su edad ya dicen más palabras... y no podés evitar preguntarte si a tu hijo le falta un poco más de estimulación o si hay algo que podrías estar haciendo diferente.'
}, {
  title: '"Pruebo cosas de Internet pero no veo un plan. No sé si lo que hago sirve."',
  desc: 'Buscaste en Google, viste videos en Instagram y probaste actividades que encontraste por Internet. Pero al final seguís con la misma duda: ¿realmente esto ayuda a mi hijo?'
}, {
  title: '"Siento que estoy desaprovechando los primeros años y eso me angustia."',
  desc: 'Sabés que los primeros años son una etapa muy importante para el desarrollo del lenguaje. Y te da miedo mirar para atrás y sentir que podrías haber hecho más.'
}, {
  title: '"Termino dándole el celular porque no tengo otra cosa para hacer."',
  desc: 'El auto, la sala de espera, cuando cocinás... hay momentos en los que el celular parece la única salida. No porque quieras, sino porque nadie te mostró una alternativa que realmente sea fácil de aplicar.'
}];
export function PainPoints() {
  return <section className="py-12 px-5 bg-white pt-[20px]" data-id="element-82">
      <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-8 text-center leading-snug" data-id="element-83">
        ¿Alguna de estas frases te suena familiar?
      </h2>

      <div className="space-y-6" data-id="element-84">
        {pains.map((pain, index) => <Reveal key={index} delay={Math.min(index * 0.05, 0.2)} data-id="element-85">
            <div className="bg-stone-50 rounded-2xl p-5 border border-stone-200" data-id="element-86">
              <div className="flex gap-3 mb-3" data-id="element-87">
                <Frown className="w-6 h-6 text-violet-500 flex-shrink-0 mt-1" data-id="element-88" />
                <h3 className="font-bold text-gray-900 text-lg leading-snug" data-id="element-89">
                  {pain.title}
                </h3>
              </div>
              <p className="text-gray-600 leading-relaxed ml-9" data-id="element-90">{pain.desc}</p>
            </div>
          </Reveal>)}
      </div>
    </section>;
}